import React from "react";
import LegalPage from "components/Legal/LegalPage.jsx";
import HelpTooltip from "components/Help/HelpTooltip.jsx";

export default function HelpPage() {
    return (
        <LegalPage title="Hilfe & Dokumentation">

            <h2>Inhaltsverzeichnis</h2>
            <ul>
                <li><a href="#uebersicht">Übersicht</a></li>
                <li><a href="#dashboard">Dashboard</a></li>
                <li><a href="#filter">Filter</a></li>
                <li><a href="#signale">Signale & Auswertungen</a></li>
                <li><a href="#sentiment">Sentiment-Karte</a></li>
                <li><a href="#rollen">Rollen & Zugriff</a></li>
                <li><a href="#faq">FAQ</a></li>
            </ul>

            <h2 id="uebersicht">Übersicht</h2>
            <p>
                kimat-online ist eine{" "}
                <HelpTooltip text="Automatisierte Auswertung von Nachrichten durch Machine Learning Modelle">
                    KI-gestützte Plattform
                </HelpTooltip>{" "}
                zur Analyse von Nachrichten und deren möglicher Relevanz für Aktien.
            </p>

            <p>
                Die Plattform stellt{" "}
                <HelpTooltip text="Keine individuelle Beratung oder Handlungsempfehlung im rechtlichen Sinne">
                    keine Anlageberatung
                </HelpTooltip>{" "}
                dar.
            </p>

            <h2 id="dashboard">Dashboard</h2>
            <p>
                Im Dashboard erhalten Sie eine Übersicht über:
            </p>
            <ul>
                <li>aktuelle News</li>
                <li>
                    bewertete{" "}
                    <HelpTooltip text="Von der KI erzeugte Einschätzungen zur möglichen Marktwirkung">
                        Signale
                    </HelpTooltip>
                </li>
                <li>Filtermöglichkeiten</li>
            </ul>

            <h2 id="filter">Filter & Suche</h2>
            <p>
                Über die Filterleiste können Sie die Daten gezielt einschränken.
            </p>
            <ul>
                <li>
                    Datum: Einschränkung des Analysezeitraums
                </li>
                <li>
                    Suche: mindestens 3 Zeichen erforderlich
                </li>
                <li>
                    <HelpTooltip text="Positive Marktinterpretation">
                        Buy
                    </HelpTooltip>,{" "}
                    <HelpTooltip text="Negative Marktinterpretation">
                        Sell
                    </HelpTooltip>,{" "}
                    <HelpTooltip text="Neutrale Einschätzung">
                        Hold
                    </HelpTooltip>
                </li>
            </ul>

            <h2 id="signale">Signale & Auswertungen</h2>
            <p>
                Ein{" "}
                <HelpTooltip text="Durch KI erzeugte Bewertung einer Nachricht">
                    Signal
                </HelpTooltip>{" "}
                beschreibt die erwartete Marktreaktion.
            </p>

            <p>
                Wichtig:{" "}
                <strong>
                    Ticker erscheinen nur, wenn tatsächlich Signale erkannt wurden.
                </strong>
            </p>

            <p>
                Dadurch werden nur aktive und relevante Marktbewegungen dargestellt.
            </p>

            <h2 id="sentiment">Sentiment-Karte</h2>

            <p>
                Die{" "}
                <HelpTooltip text="Aggregierte Auswertung aller Nachrichten nach Stimmung">
                    Sentiment-Karte
                </HelpTooltip>{" "}
                zeigt die aktuelle Marktstimmung.
            </p>

            <p>
                Sie basiert auf:
            </p>

            <ul>
                <li>
                    <HelpTooltip text="Analyse von Sprache und Tonalität">
                        Textanalyse
                    </HelpTooltip>
                </li>
                <li>
                    <HelpTooltip text="Erkennung wichtiger Begriffe wie Gewinn, Krise etc.">
                        Schlüsselbegriffen
                    </HelpTooltip>
                </li>
                <li>
                    <HelpTooltip text="Einfluss von Quelle und Relevanz">
                        Gewichtung
                    </HelpTooltip>
                </li>
            </ul>

            <p>
                Interpretation:
            </p>

            <ul>
                <li><strong>Positiv:</strong> Markt eher optimistisch</li>
                <li><strong>Negativ:</strong> Markt eher vorsichtig</li>
                <li><strong>Neutral:</strong> unklare Lage</li>
            </ul>

            <h2 id="rollen">Rollen & Zugriff</h2>
            <p>
                Einige Funktionen sind rollenbasiert eingeschränkt.
            </p>

            <h2 id="faq">FAQ</h2>

            <p><strong>Ist das eine Kaufempfehlung?</strong></p>
            <p>
                Nein – es handelt sich um{" "}
                <HelpTooltip text="Automatisch erzeugte Bewertung ohne Garantie">
                    KI-basierte Signale
                </HelpTooltip>.
            </p>

            <p><strong>Wie zuverlässig ist das?</strong></p>
            <p>
                Die Ergebnisse können unvollständig oder fehlerhaft sein.
            </p>

        </LegalPage>
    );
}